import { axiosRequest } from '@/util/axios-request'

// 日程类型
export const typeInfoFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getcalendartype',
    data
  })
}
// 日程列表
export const listFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getcalendarbyday',
    data
  })
}
// 新建日程
export const createFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/addcalendar',
    data
  })
}

// 删除日程
export const delFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/delcalendar',
    data
  })
}
// 编辑日程
export const editFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/updatecalendar',
    data
  })
}

// 待离职列表
export const toLeaveInfoFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getcalendarbymonth',
    data
  })
}

// 获取有日程的时间
export const hasSpotFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getcalendarbymonth',
    data
  })
}

// 员工出勤
export const attendanceFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/gettodayattendance',
    data
  })
}
// 司龄
export const servingFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getcompanyage',
    data
  })
}
// 组织架构
export const orgFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getfirstdepartmenthc',
    data
  })
}
// 人员流动
// /web/dashboard/getrecentjoinandleavecount?recent_day=7
export const flowFn = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getrecentjoinandleavecount',
    data
  })
}
// tab角标数量
export const tabCount = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getcount',
    data
  })
}

export const gettodayleaveoffice = (data) => {
  return axiosRequest({
    url: '/web/dashboard/gettodayleaveoffice',
    data
  })
}
/*
导出接口
/web/dashboard/exportleaveoffice?search=xxxx} data
*/
export const exportleaveoffice = (data) => {
  return axiosRequest({
    url: '/web/dashboard/exportleaveoffice',
    data
  })
}

// 待转正列表
export const getStaffRegular = (data) => {
  return axiosRequest({
    url: '/web/dashboard/getStaffRegular',
    data
  })
}

// 设置转正日期、提醒日期
export const setRegularEnv = (data) => {
  return axiosRequest({
    url: '/web/staff_regular/setRegularEnv',
    data
  })
}

// 获取转正日期、提醒日期
export const getRegularEnv = (data) => {
  return axiosRequest({
    url: '/web/staff_regular/getRegularEnv',
    data
  })
}

// 提醒消息列表
export const noticeConfigLists = (data) => {
  return axiosRequest({
    url: '/web/staff_regular/noticeConfigLists',
    data
  })
}

// 添加转正提醒
export const saveNoticeConfig = (data) => {
  return axiosRequest({
    url: '/web/staff_regular/saveNoticeConfig',
    data
  })
}

// 提醒消息列表
export const delNoticeConfig = (data) => {
  return axiosRequest({
    url: '/web/staff_regular/del',
    data
  })
}

// 修改提醒状态
export const switchNoticeConfig = (data) => {
  return axiosRequest({
    url: '/web/staff_regular/switch',
    data
  })
}
